/**
 * Fälligkeits-Badge (G-7-Ampel): zeigt das Datum als Badge in der Ampelfarbe
 * aus format.urgencyClasses (rot < 30 Tage, orange < 90, sonst grün).
 * Ohne Datum: dezentes "—".
 */

import { Badge } from "@/components/ui/badge"
import { fmtDate, urgencyClasses } from "@/lib/format"
import { cn } from "@/lib/utils"

/** Resttage bis zu einem "YYYY-MM-DD"-Datum (negativ = abgelaufen) */
function daysUntil(iso: string): number {
  const [y, m, d] = iso.slice(0, 10).split("-").map(Number)
  const target = Date.UTC(y, m - 1, d)
  const now = new Date()
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate())
  return Math.round((target - today) / 86_400_000)
}

export function DueBadge({ date }: { date: string | null | undefined }) {
  if (!date) return <span className="text-muted-foreground">—</span>
  const days = daysUntil(date)
  return (
    <Badge
      variant="outline"
      className={cn("whitespace-nowrap tabular-nums", urgencyClasses(days))}
      title={days < 0 ? `Seit ${-days} Tagen abgelaufen` : `Noch ${days} Tage`}
    >
      {fmtDate(date)}
    </Badge>
  )
}
